import { RechargeSansInscriptionService } from './../../api/recharge-sans-inscription.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { cardMaskFactory, ccvMask, expiryMask } from './payment.mask';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { expiryStringValidator } from './payment.validator';



@Component({
  selector: 'app-payment-recharge-sans-inscription',
  templateUrl: './payment-recharge-sans-inscription.component.html',
  styleUrls: ['./payment-recharge-sans-inscription.component.scss']
})
export class PaymentRechargeSansInscriptionComponent implements OnInit {

  constructor(private rechargeSansInscriptionService: RechargeSansInscriptionService, private router: Router, private snackBar: MatSnackBar, private formBuilder: FormBuilder, private sanitizer: DomSanitizer) { this.getInfoRecharge() }


  numberMask = cardMaskFactory();
  expiryMask = expiryMask;
  ccvMask = ccvMask;
  subscription: Subscription;
  carteList: any;
  isCarteType = false;


  ngOnInit(): void {
    this.createForm();
  }

  formGroup: FormGroup;

  infoUser: any;
  stationDetail: any



  createForm() {
    let passwordCheck = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.{8,})/;
    let visa = /^[0-9 ]{19}$/;
    let numberCardregex: RegExp = /^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13})$/
    let caracereregex: RegExp = /^[a-zA-Z -]+$/;
    let cvcregex: RegExp = /^[0-9]{3,4}$/;

    this.formGroup = this.formBuilder.group({
      numberCard: [null, [Validators.required, Validators.minLength(18), Validators.maxLength(19)]],
      name: [null, [Validators.required, Validators.pattern(caracereregex), Validators.maxLength(30)]],
      expiration: [null, [Validators.required, expiryStringValidator()]],
      code: [null, [Validators.required, Validators.pattern(cvcregex)]],
      carteType:[null, [Validators.required]]
    }
    );

      // Observer sur le champ numberCard
      this.formGroup.get('numberCard')?.valueChanges.subscribe(value => {
        this.onNumberCardComplete(value);
      });
  }



  sanitizeImageUrl(imageUrl: any): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }


  public getImage() {
    return this.sanitizer.bypassSecurityTrustUrl("/assets/img/payment/cb.jpeg")
  }



  getErrorNumberCard() {
    if (this.formGroup.get('numberCard').hasError('minlength')) { return 'Nom sur la carte non valide' }
    if (this.formGroup.get('numberCard').hasError('required')) { return 'Numéro de carte requis' }
    // if(this.formGroup.get('numberCard').hasError('pattern')) { return 'Numéro de carte non valide' }

    if (this.formGroup.get('numberCard').hasError('maxlength')) { return 'Nom sur la carte non valide' }
  }

  getErrorNameCard() {
    if (this.formGroup.get('name').hasError('required')) { return 'Nom sur la carte requis' }
    if (this.formGroup.get('name').hasError('pattern')) { return 'Nom sur la carte non valide' }
    if (this.formGroup.get('name').hasError('maxlength')) { return 'Nom sur la carte non valide' }
  }

  getErrorExpirationCard() {
    return this.formGroup.get('expiration').hasError('required') ? "Date d'expiration requise" :
      this.formGroup.get('expiration').hasError('expired') ? "Date d'expiration non valide" : "Date d'expiration non valide";
  }

  getErrorCodeCard() {
    return this.formGroup.get('code').hasError('required') ? 'Code requis' :
      this.formGroup.get('code').hasError('pattern') ? 'Code non valide' : 'Code non valide';
  }

   getErrorTypeCard() {
    return this.formGroup.get('carteType').hasError('required') ?  'Type requis' :
        'Type requis';
  }




  get f() { return this.formGroup.controls; };


  openSnackBar(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 20000,
    });
  }



  getInfoRecharge() {
    this.subscription = this.rechargeSansInscriptionService.currentrecharge_info.subscribe(res => {
      console.log(res);
      if (res) {
        this.stationDetail = res.station
        this.infoUser = res.user
      }
    })
  }


  //send card 
  sendCard() {


    if (this.formGroup.invalid) {
      return;
    }

    let userData = this.formGroup.value;


    if (/\s/.test(userData.numberCard)) {
      var numberCard = userData.numberCard.replace(/\s/g, '');
      userData.numberCard = numberCard.replace(/_/g, '')
    }


    if (userData.numberCard.length < 15) {
      this.openSnackBar('Le numéro de votre carte bancaire est invalide')
      return;
    }
   
    userData.cvc = userData.code
    

    if (/\s/.test(userData.expiration)) {
      var expireCard = userData.expiration.replace(/\s/g, '');
      userData.expiration = expireCard.replace(/_/g, '');
    }

    userData.month = userData.expiration.substring(0, 2)
    userData.year = userData.expiration.substring(3)

    userData.network = userData.carteType

    console.log(userData)

    var returnurl = location.host

    this.rechargeSansInscriptionService.sendCard(userData, this.infoUser.name, returnurl).subscribe(
      data => {

        console.log(data)
        if (data.code === 200) {
          console.log(data.code)
          this.router.navigate([`/payment/confirm`]);
        }
        if (data.code === 202) {
          console.log(data.code)
          console.log(data.data)
          if (data.data.next_action === "use_stripe_sdk") {
            window.location.href = data.data.next_action.use_stripe_sdk.stripe_js
          }
          else {
            window.location.href = data.data.next_action.redirect_to_url.url
          }
        }
        if (data.code === 500) {
          console.log(data.code)
          this.openSnackBar(data.message)
        }
      },
      err => {
        console.log(err)
        this.openSnackBar('Votre paiement a été refusé')
      });

  }


    onNumberCardComplete(value: string) {
    // Suppression des espaces avant vérification
    const cleanedValue = value.replace(/\s/g, '');
  
    // Vérification que la valeur ne contient que des chiffres
    const isNumeric = /^\d+$/.test(cleanedValue);
  
    // Vérification si le numéro est complet (par exemple, 16 ou 19 chiffres pour Visa/Mastercard) et qu'il ne contient que des chiffres
    if ((cleanedValue.length === 16 || cleanedValue.length === 19) && isNumeric) {
      console.log('Numéro de carte complet : ', cleanedValue);
      // Votre logique ici, par exemple appeler une autre fonction
      // this.processCardNumber(cleanedValue);
      this.isCarteType = true
      this.subscribeToCarteType(cleanedValue)
    } else {
      console.log('Numéro de carte invalide ou incomplet');
      this.isCarteType = false
    }
  }



  subscribeToCarteType(card_num) {
    this.rechargeSansInscriptionService.getCardType(card_num).subscribe(
      data => {
        // this.IsWait = false;
        this.carteList = data
      },
      err => {
        console.log(err)
      });
  }






}
